import React,{Component} from 'react';

class AddUserView extends Component{

  constructor(props){
    super(props);
   this.updateInputValue = this.updateInputValue.bind(this);
   this.state ={user:{}};
   this.saveUser = this.saveUser.bind(this);
  }
  updateInputValue(evt) {
    let inputName =  evt.target.name;

    let user = this.state.user;
    user[inputName]= evt.target.value;
    this.setState({user:user});

   }
   




   
   saveUser(){
     this.props.saveUser(this.state.user);
   }
   

   

  render(){
    window.scrollTo(0, 0); 
       
    
   
 
    return(

      <div className="addWorkerView">
       <div className="workersListHeader alert alert-info">Käyttäjän tiedot</div>
        <form>
          <label htmlFor="userName" ><span>Käyttäjätunnus</span><input type="text"  name="newUsername"  value={this.state.user.newUsername} onChange={evt => this.updateInputValue(evt)} /></label>
          <label htmlFor="name" ><span>Nimi</span><input type="text"  name="name"  value={this.state.user.name} onChange={evt => this.updateInputValue(evt)} /></label>
        
          <label htmlFor="password" ><span>Salasana</span><input type="password"  name="password"  value={this.state.user.password} onChange={evt => this.updateInputValue(evt)} /></label>
          <label htmlFor="organization" ><span>Organisaatio</span><input type="text"  name="organization"  value={this.state.user.organization} onChange={evt => this.updateInputValue(evt)} /></label>
          
          <label htmlFor="phone" ><span>Puh</span><input type="tel"   value={this.state.user.phone} name="phone" onChange={evt => this.updateInputValue(evt)} /></label>
          <label htmlFor="email" ><span>Sähköposti</span><input type="email"   value={this.state.user.email} name="email" onChange={evt => this.updateInputValue(evt)} /></label>
       
          <button type="button" className="btnThirdButton" onClick={this.saveUser}>Tallenna</button>
          <button type="button" className="btnClose" onClick={this.props.changeToUsersView}>Peruuta</button>
        </form>
    </div>
)
}
}
export default AddUserView;
